class HXFormFieldUtils {
    /**
     * Prueft und formatiert einen Time-Text
     * Beispiele '1' => '01:00', '' => '', '25:00' => null, 24:00 => '24:00'
     * @param {string|int|null} text
     * @param {boolean} withSeconds
     * @param {int|null} minuteInterval
     * @returns {string|null} liefert aufformierten Text, oder wenn Inhalt von 'text' keing gueltiges Datum dann wird null zurueck gegeben
     */
    static getTimeTextFormated(text,withSeconds,minuteInterval) {
        var value = hx.replace(text, " ", "");
        var formatedTime = null;

        if(value != ""){
            var hour = 0, minute = 0, second = 0;
            var validTime = false;
            var split = hx.explode(":", value);
            if(hx.count(split) > 3) return null;                               // Abfangen: z.B. 10:10:10:10:10
            if(hx.count(split) == 1 && hx.isInt(split[0])){                    // nur Stundenangabe
                var number = hx.cint(split[0]);
                if(String(number).length == 1 || String(number).length == 2){
                    hour = number;
                }else if(String(number).length == 3){                          // 3 Zeichen: 1. Stunde, 830 ==> 8:30
                    hour = hx.cint(String(number).substr(0, 1));
                    minute = hx.cint(String(number).substr(1, 2));
                }else if(String(number).length == 4){                         // 4 zeichen: 0830 ==> 08:30
                    hour = hx.cint(String(number).substr(0, 2));
                    minute = hx.cint(String(number).substr(2, 2));
                }else if(String(number).length == 5){                         // 5 Zeichen: 08305 ==> 08:30:05
                    hour = hx.cint(String(number).substr(0, 2));
                    minute = hx.cint(String(number).substr(2, 2));
                    second = hx.cint(String(number).substr(4, 1));
                }else if(String(number).length >= 6){                         // 6 Zeichen oder mehr: 0830522 ==> 08:30:22
                    hour = hx.cint(String(number).substr(0, 2));
                    minute = hx.cint(String(number).substr(2, 2));
                    second = hx.cint(String(number).substr(4, 2));
                }
            }else if(hx.count(split) == 2 && hx.isInt(split[0]) && hx.isInt(split[1])){                          // 08:30
                hour = hx.cint(split[0].substr(0, 2));
                minute = hx.cint(split[1].substr(0, 2));
            }else if(hx.count(split) == 3 && hx.isInt(split[0]) && hx.isInt(split[1]) && hx.isInt(split[2])){    // 08:20:12
                hour = hx.cint(split[0].substr(0, 2));
                minute = hx.cint(split[1].substr(0, 2));
                second = hx.cint(split[2].substr(0, 2));
            }
            if(hour >= 0 && hour <=23 && Math.max(minute, second, 59) == 59 && Math.min(minute, second, 0) == 0){
                validTime = true;
            }else if(hour == 24 && minute == 0 && second == 0){
                validTime = true;
            }
            if (hx.cint(minuteInterval) !== 0){
                // wenn die Minuten im Intervall sind, darf die Sekunde nicht gesetzt sein:
                second=0;
            }
            if(validTime){
                if (hx.cint(minuteInterval)>0){
                    minute = hx.round(minute / hx.cint(minuteInterval)) * hx.cint(minuteInterval);
                    if(minute >= 60){
                        minute = 0;
                        hour ++;
                        if(hour > 23) hour = 0;
                    }
                }
                if(withSeconds){
                    formatedTime = hx.format00(hour) + ":" + hx.format00(minute) + ":" + hx.format00(second);
                }else{
                    formatedTime =  hx.format00(hour) + ":" + hx.format00(minute);
                }
            }else{
                formatedTime =  null;
            }
        }else{
            formatedTime = value;
        }
        return formatedTime;
    }

    /**
     * Prueft und formatiert einen Date-Text
     * Beispiele z.B. '1.1.23' -> '01.01.2023', '01012023' -> '01.01.2023'
     * @param {string} text
     * @returns {string|null} liefert aufformierten Text, oder wenn Inhalt von 'text' keing gueltiges Datum dann wird null zurueck gegeben
     */
    static getDateTextFormated(text) {
        var t1 = String(text);
        var d;
        var t2 = t1;
        var t = 0, m = 0, j = 0;
        var tx = 0, mx = 0, jx = 0;
        if(t1 == ""){
            return null;
        }
        var tmp = t1.split(".");
        if(tmp.length != 3 && tmp.length != 1){
            return null;
        }
        if(tmp.length == 1){
            if(t2.length == 8){
                tx = t2.substr(0, 2);
                mx = t2.substr(2, 2);
                jx = t2.substr(4, 4);
            }else if(t2.length == 6){
                tx = t2.substr(0, 2);
                mx = t2.substr(2, 2);
                jx = t2.substr(4, 2);
            }else if(t2.length == 4){
                var kwx = t2.substr(0, 2);
                jx = t2.substr(2, 2);
                j = hx.cint(jx);
                var kw = hx.cint(kwx);
                if(isNaN(kw) || isNaN(j)){
                    return null;
                }
                kw = kw - 1;
                j = j + 2000;
                // ersten Donnerstag des Jahres:
                var datDonnerstag = new Date(j, 0, 1);
                for (var dayAdd = 2; dayAdd<=8; dayAdd++) {
                    if(datDonnerstag.getDay() != 4) datDonnerstag = new Date(j, 0, dayAdd);
                }

                // Jetzt Montag suchen
                var datMontag = datDonnerstag;
                while (datMontag.getDay() != 1) {
                    datMontag = new Date(datMontag.getFullYear(), datMontag.getMonth(), datMontag.getDate() - 1);
                }
                var datum = new Date(dat_mon.getFullYear(), dat_mon.getMonth(), dat_mon.getDate() + (kw * 7));
                tx = datum.getDate();
                mx = datum.getMonth() + 1;
                jx = datum.getFullYear();
            }else{
                return null;
            }
            t = hx.cint(tx);
            m = hx.cint(mx);
            j = hx.cint(jx);
        }
        if(tmp.length == 3){
            t = hx.cint(tmp[0]);
            m = hx.cint(tmp[1]);
            j = hx.cint(tmp[2]);
        }
        if(isNaN(t) || isNaN(m) || isNaN(j)){
            return null;
        }
        if(t < 1 || t > 31)      return null;
        if(m < 1 || m > 12)      return null;
        if(j < 70 && j >= 0)     j = j + 2000;
        if(j >= 70 && j < 100)   j = j + 1900;
        if(j < 1000 || j > 9999) return null;

        d = new Date(j, m - 1, t);
        if (d=== null) {
            return null;
        }  else {
            return hx.format00(d.getDate()) + "." + hx.format00(d.getMonth()+1) + "." + d.getFullYear();
        }
    }

    /**
     * Abhaengig vom Tastendruck im 'event.key' wird zurueck gegeben, ob diese Eingabe erlaubt ist allowkey=true
     * Bei bestimmten Tassten wird der 'timeText' entsprechend angepasst und zurueck gegeben
     * @param {string} timeText
     * @param {event} event
     * @param {int} minuteInterval
     * @param {boolean} withSeconds
     * @param {string} timeNow
     * @return {object} {{allowKey : boolean, timeText:string|null}};
     */
    static getTimeTextKeyEventResult(timeText, event, minuteInterval, withSeconds= false, timeNow = null) {
        var keyPressed = event.key;
        var result = {allowKey : false, timeText:null};

        //Eingabezeichen zulassen (schliesst auch das Numpad mit ein)
        if (hx.value_in(keyPressed, "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ":")) {
            result.allowKey = true;
        }

        //Steuertasten zulassen (schliesst auch das Numpad mit ein)
        if (hx.value_in(keyPressed, "Tab", "Backspace", "Delete", "Enter", "End", "Home", "ArrowLeft", "ArrowRight", "Escape")) {
            result.allowKey = true;
        }

        //Tastenkombinationen Windows/Mac zulassen  Ctrl/Cmd -C , Ctrl/Cmd -V, Ctrl/Cmd -A, Ctrl/Cmd -X
        if ((event.ctrlKey || event.metaKey) && hx.value_in(keyPressed, "c", "v", "a", "x")) {
            result.allowKey = true;
        }

        //Heutiges Datum + Zeit eintragen
        if (hx.value_in(keyPressed, "h", "j", "t", "n")) {
            if (timeNow!==null) {
                result.timeText = timeNow;
            }else{
                result.timeText = hx.formatTime(hx.now(), true); //wird hier mit Sekunden aufformatiert
            }
            result.allowKey = false;
        }

        //+/-
        if (hx.value_in(keyPressed, "+", "ArrowUp") && !event.ctrlKey) {
            if (timeText === "") timeText = hx.formatTime(hx.now(),true);
            timeText = HXFormFieldUtils.getTimeTextFormated(timeText, withSeconds, minuteInterval);

            if (timeText !== null) {
                var hour = hx.cint(hx.substr(timeText, 0, 2));
                var minute = hx.cint(hx.substr(timeText, 3, 2));

                if (minuteInterval === null || minuteInterval === 0) minuteInterval=1;

                minute = hx.round(minute/minuteInterval) * minuteInterval;
                minute=minute + minuteInterval;
                if (minute >= 60) {
                    hour++;
                    minute = minute - 60;
                }
                if (hour == 24) {
                    hour = 0;
                    minute = 0;
                }
                if (withSeconds) {
                    timeText = hx.format00(hour) + ":" + hx.format00(minute) + ":" + hx.format00(0);
                } else {
                    timeText = hx.format00(hour) + ":" + hx.format00(minute);
                }
                result.timeText = timeText;
                result.allowKey = false;
            }

        } else if (hx.value_in(keyPressed, "-", "ArrowDown") && !event.ctrlKey) {
            if (timeText === "") timeText = hx.formatTime(hx.now(),true);
            timeText = HXFormFieldUtils.getTimeTextFormated(timeText, withSeconds, minuteInterval);

            if (timeText !== null) {
                var hour = hx.cint(hx.substr(timeText, 0, 2));
                var minute = hx.cint(hx.substr(timeText, 3, 2));

                if (minuteInterval === null || minuteInterval === 0) minuteInterval=1;

                minute = hx.round(minute/minuteInterval) * minuteInterval;
                minute=minute - minuteInterval;
                if (minute < 0) {
                    hour--;
                    if (hour<0){
                        hour=0;
                        minute=0;
                    }else{
                        minute = minute + 60;
                    }
                }
                if (hour <0 ) hour = 0;
                if (withSeconds) {
                    timeText = hx.format00(hour) + ":" + hx.format00(minute) + ":" + hx.format00(0);
                } else {
                    timeText = hx.format00(hour) + ":" + hx.format00(minute);
                }
                result.timeText = timeText;
                result.allowKey = false;
            }
        }
        return result;
    }

    /**
     * Abhaengig vom Tastendruck im 'event.key' wird zurueck gegeben, ob diese Eingabe erlaubt ist allowkey=true
     * Bei bestimmten Tassten wird der 'dateText' entsprechend angepasst und zurueck gegeben
     * @param {string} dateText aktueller Inhalt des Datumsfeldes
     * @param {event} event
     * @param {string} defaultTime
     * @returns {object} {{allowKey: boolean, dateText: string, timeText: string}}
     */
    static getDateTextKeyEventResult(dateText, event, defaultTime=null) {
        var keyPressed = event.key;
        var result = {allowKey : false, dateText:null, timeText:null};

        //Eingabezeichen zulassen (schliesst auch das Numpad mit ein)
        if (hx.value_in(keyPressed, "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", ".")) {
            result.allowKey = true;
        }

        //Steuertasten zulassen (schliesst auch das Numpad mit ein)
        if (hx.value_in(keyPressed, "Tab", "Backspace", "Delete", "Enter", "End", "Home", "ArrowLeft", "ArrowRight", "Escape")) {
            result.allowKey = true;
        }

        //Tastenkombinationen Windows/Mac zulassen  Ctrl/Cmd -C , Ctrl/Cmd -V, Ctrl/Cmd -A, Ctrl/Cmd -X
        if ((event.ctrlKey || event.metaKey) && hx.value_in(keyPressed, "c", "v", "a", "x")) {
            result.allowKey = true;
        }

        //Heutiges Datum + Zeit eintragen
        if (hx.value_in(keyPressed, "h", "j", "t", "n")) {
            var d = new Date();
            result.dateText = hx.formatDate(hx.dateSerial(d.getFullYear(),d.getMonth()+1,d.getDate()));
            if (defaultTime===null) defaultTime = hx.formatTime(d.getTime(),false);
            result.timeText = defaultTime;
        }

        //enthaellt Text gueltiges Daten dann kann +/- Taste zur Awendung kommen
        var ad = null;
        var dat = null;
        if (dateText==='') {
            ad = new Date(); // bei leerem Feld: Heute
        } else {
            dat = hx.text2date(dateText);
            if (dat != null) ad = new Date(dat);
        }
        if(ad != null){
            var at = ad.getDate();
            var am = (ad.getMonth()+1);
            var aj = ad.getFullYear();
            if(hx.value_in(keyPressed, "+", "ArrowUp") && !event.ctrlKey) result.dateText = hx.formatDate(hx.dateSerial(aj,am,at+1));
            if(hx.value_in(keyPressed, "-", "ArrowDown") && !event.ctrlKey) result.dateText = hx.formatDate(hx.dateSerial(aj,am,at-1));
        }
        return result;
    }

    /**
     * Oeffnet CMSHX-Medienpool. Wird von HXFormFieldReference und HXFormFieldTextareaHTML verwendet
     * @param {string} root
     * @param {string} stateparam
     */
    static openCmshxMedienpool(root,stateparam){
        var selection = window.getSelection();
        var selectionSaved = "";
        if(selection.rangeCount > 0){
            selectionSaved = selection.getRangeAt(0); // wenn vorhanden, Textauswahl speichern
        }

        var popup = window.open(root + "cmshx/cmshx_frontend/medienpool/index.php?sp=" + stateparam,
            "LINK",
            "width=910,resizable=yes,height=710,scrollbars=yes,statusbar=yes,toolbars=no,dependent=yes");
        popup.onload = () => {
            var selection = window.getSelection();
            selection.removeAllRanges();
            if(selectionSaved != "") selection.addRange(selectionSaved); // Textauswahl wieder herstellen
            popup.focus();
        }
    }

}